module.exports = __webpack_public_path__ + "static/media/send-final.c13cf2ea.svg";